import { apiServiceConstants } from "../../../constants/apiService.constants";
import { apiService } from "../../../services/apiService";
import { utilService } from "../../../services/utilService";
import {
  PhaseDetailsModel,
  PhaseDetailsModelResult,
  Result,
  StatusBoardList,
  StatusBoardListModel,
  StatusBoardListReq,
} from "./Menu.model";

const getStatusBoardList = async (
  params: StatusBoardListReq
): Promise<StatusBoardListModel> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/my-statusboard/list/?reg_code=${utilService.getNetwork()}&page=${
        params.page
      }`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const statusBoardListResp = res as StatusBoardListModel;
      var statusBoardListResponse: any;
      // An empty array is truthy, so this used to call
      // setStatusBoardListModel(result[0]) with undefined whenever the account had
      // no status boards. That threw on payload.count, the catch below turned it
      // into isSuccess: false, and handleErrorResponse was an empty function -- so
      // clicking "Status Board" did nothing at all, with no error anywhere.
      const firstPage: any = Array.isArray(statusBoardListResp.result)
        ? statusBoardListResp.result?.[0]
        : statusBoardListResp.result;
      if (firstPage) {
        statusBoardListResponse = setStatusBoardListModel(firstPage);
      } else {
        // No status boards: a valid empty page, not a failure.
        statusBoardListResponse = { count: 0, previous: null, next: null, data: [] };
      }

      const result: StatusBoardListModel = {
        isSuccess: true,
        result: statusBoardListResponse,
        status: statusBoardListResp.status,
        message: statusBoardListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: StatusBoardListModel = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getPhaseDetails = async (params: any): Promise<PhaseDetailsModel> => {
  const respApiResult = await apiService
    .apiCall(
      `auth/get-phase3-status/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const phaseStatusDetailsResp = res as PhaseDetailsModel;
      var phaseStatusResponse: any;
      if (phaseStatusDetailsResp.result) {
        phaseStatusResponse = setPhaseDetailsModel(
          phaseStatusDetailsResp.result
        );
      }

      const result: PhaseDetailsModel = {
        isSuccess: true,
        result: phaseStatusResponse,
        status: phaseStatusDetailsResp.status,
        message: phaseStatusDetailsResp.message,
      };
      console.log(result);
      return result;
    })
    .catch((err) => {
      const result: PhaseDetailsModel = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const activateN2NListing = async (params: any): Promise<PhaseDetailsModel> => {
  const respApiResult:any = await apiService
    .apiCall(
      `n2n-communication/user-listing/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const phaseStatusDetailsResp = res;
      
      return phaseStatusDetailsResp;
    })
    .catch((err) => {
      const result: PhaseDetailsModel = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const setPhaseDetailsModel = (payload: Array<PhaseDetailsModelResult>) => {
  let DataListArray = payload.map((object: PhaseDetailsModelResult) => {
    return {
      phase3Status: object.phase_3_status,
      phase2Status: object.phase_2_status,
    };
  });
  return DataListArray;
};

const setStatusBoardListModel = (payload: Result) => {
  var statusBoardListObject = {
    count: payload.count,
    previous: payload.previous,
    next: payload.next,
    data: setDataList(payload.data),
  };

  return statusBoardListObject;
};

const setDataList = (payload: Array<StatusBoardList>) => {
  let DataListArray = payload.map((object: StatusBoardList) => {
    return {
      id: object.id,
      name: object.name,
    };
  });
  return DataListArray;
};

const handleErrorResponse = (message?: string) => {
  // Was an empty function, which is why a failed status board fetch produced no
  // navigation, no empty state and no error -- the menu item simply appeared dead.
  console.error("[Menu] status board list request failed:", message);
};

export const menuService = {
  getStatusBoardList,
  handleErrorResponse,
  getPhaseDetails,
  activateN2NListing,
};
